import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function callDashboardList(params) {
  return authPost(`${baseUrl}/Agent5.ashx`, params);
}
